import { Image, styled } from '@arpeggi/ui'

const Root = styled('div', {
  background: '$gray0200',
  padding: '8px',
  borderRadius: '8px',
  boxSizing: 'border-box',
  userSelect: 'none',
  transition: 'all 100ms ease',
  variants: {
    clickable: {
      true: {
        cursor: 'pointer',
        '&:hover': { transform: 'translateY(-2px)' },
        '&:active': { transform: 'translateY(1px)' }
      }
    }
  }
})

const ThumbnailWrapper = styled('div', {
  position: 'relative',
  '&::after': {
    content: '',
    display: 'block',
    paddingBottom: '100%'
  }
})

const Tag = styled('div', {
  top: '8px',
  position: 'absolute',
  left: '8px',
  borderRadius: '4px',
  text: '14',
  fontWeight: 700,
  padding: '4px 8px',
  variants: {
    variant: {
      default: {
        background: '$whiteA900',
        backdropFilter: 'blur(4px)',
        color: '$black'
      },
      success: {
        background: 'linear-gradient(90deg, #62D15D 0%, #42BBA5 100%)',
        color: '$white'
      },
      disabled: {
        background: '$blackA300',
        backdropFilter: 'blur(4px)',
        color: '$white'
      },
      primary: {
        background: '$blackA900',
        backdropFilter: 'blur(4px)',
        color: '$white'
      }
    }
  },
  defaultVariants: {
    variant: 'default'
  }
})

const Thumbnail = styled(Image, {
  borderRadius: '4px',
  position: 'absolute',
  width: '100%',
  height: '100%'
})

const Content = styled('div', {
  paddingTop: '8px',
  width: '200px',
  overflow: 'hidden'
})

const Text = styled('div', {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  variants: {
    color: {
      primary: { color: '$blackA900' },
      secondary: { color: '$blackA400' }
    },
    variant: {
      sub: {
        text: '14',
        fontWeight: 500
      },
      title: {
        text: '18',
        fontWeight: 700,
        marginBottom: '12px'
      },
      caption: {
        text: '12',
        fontWeight: 400
      }
    }
  },
  defaultVariants: {
    variant: 'sub',
    color: 'primary'
  }
})

export const Card = { Root, ThumbnailWrapper, Thumbnail, Tag, Content, Text }
